import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();

  return <div>{isAuthenticated ? <Outlet /> : <Navigate to={"/login"} />}</div>;
};

export default ProtectedRoute;
